import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

Vue.use(Vuetify)

/*
 * Tema renkleri = frontend redesign paleti (indigo-600 brand + slate nötr +
 * rose danger). Böylece `color="primary"` / `color="error"` kullanan ham
 * Vuetify sayfaları da tek tek elden geçirilmeden panelin geri kalanıyla
 * aynı renge oturuyor. Hex karşılıkları: src/assets/admin/variables.css
 * customProperties → CSS'te `var(--v-primary-base)` olarak da erişilebilir.
 */
export default new Vuetify({
  theme: {
    options: { customProperties: true },
    themes: {
      light: {
        primary: '#4f46e5',
        secondary: '#64748b',
        accent: '#6366f1',
        error: '#e11d48',
        info: '#4f46e5',
        success: '#047857',
        warning: '#b45309'
      }
    }
  }
})
